import {
  BankOutlined,
  CheckSquareOutlined,
  EditOutlined,
  MessageOutlined,
} from '@ant-design/icons';

import type { ComponentType } from 'react';

export type ComposerMode =
  | 'message'
  | 'task'
  | 'comment'
  | 'organization_comment';

export interface ComposerModeConfig {
  id: ComposerMode;
  label: string;
  IconComponent: ComponentType<{
    className?: string;
    style?: React.CSSProperties;
  }>;
  placeholder: string;
}

export const COMPOSER_MODES: readonly ComposerModeConfig[] = [
  {
    id: 'message',
    label: 'Сообщение',
    IconComponent: MessageOutlined,
    placeholder: 'Введите сообщение',
  },
  {
    id: 'task',
    label: 'Задача',
    IconComponent: CheckSquareOutlined,
    placeholder: 'Опишите задачу',
  },
  {
    id: 'comment',
    label: 'Комментарий',
    IconComponent: EditOutlined,
    placeholder: 'Введите комментарий',
  },
  {
    id: 'organization_comment',
    label: 'Комментарий к организации',
    IconComponent: BankOutlined,
    placeholder: 'Введите комментарий к организации',
  },
];

export const DEFAULT_COMPOSER_MODE: ComposerMode = 'message';
